import { computed } from 'vue';
import { usePage } from '@inertiajs/inertia-vue3';
export default function useBulkPurchase() {
    const { props: pageProps } = usePage();
    const bulkPurchase = computed(() => pageProps.value.bulkPurchase);
    const examinations = computed(() => pageProps.value.examinations);
    const limit = computed(() => pageProps.value.limit);
    return {
        bulkPurchase,
        examinations,
        limit,
    };
}
